import {FC, useEffect} from 'react'
import clsx from 'clsx'
import {useLocation} from 'react-router'
import {checkIsActive, KTIcon, toAbsoluteUrl, WithChildren} from '../../../helpers'
import {useLayout} from '../../core'
import {useMetronicAsideHover} from '../../../../components/useMetronicAsideHover'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  iconDynamicColor?: string
}

const AsideMenuItemWithSub: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  hasBullet,
  iconDynamicColor,
}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  const onHover = useMetronicAsideHover()

  return (
    <div
      className={clsx('menu-item', {'here show': isActive}, 'menu-accordion')}
      data-kt-menu-sub='accordion'
      data-kt-menu-trigger='click'
    >
      <span className='menu-link'>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && (
          <span className={`menu-icon ${!onHover && 'w-100'}`}>
            {/*<KTIcon iconName={icon} className='fs-2' />*/}
            <img
              src={toAbsoluteUrl(`/media/icons/menu/${icon}`)}
              alt='logo'
              width={35}
              height={35}
            />
          </span>
        )}
        <span className='menu-title mx-2 '>{title}</span>
        <span className='menu-arrow'></span>
      </span>
      <div
        className={clsx(
          'menu-sub menu-sub-accordion',
          {'menu-active-bg': isActive},
          !onHover && 'menu-sub-collapsed'
        )}
        style={{
          height: !onHover ? '0px' : 'auto',
          margin: !onHover ? '0' : '0.75rem', // m-3
          overflow: 'hidden',
        }}
      >
        {children}
      </div>
    </div>
  )
}

export {AsideMenuItemWithSub}
